import { ToastTemplateRegistryService } from './toast-template-registry.service';
import { ToastServicev2 } from '@app/shared/toast/services/toast-servicev2.service';

export const services = [ToastServicev2, ToastTemplateRegistryService];

export * from './toast-template-registry.service';
export * from './toast-servicev2.service';
